export const mps_tooltip_icon = 'mps_tooltip_icon';

export const editor_tooltip_box = 'editor-tooltip-box';
